export const Environment = {
  BACKEND_API: process.env.REACT_APP_BACKEND_API,
};
